$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Email Signup


  const $emailSignup = $('.emailSignup');
  $emailSignup.find('.inputFieldTextbox').val('');
  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Enter Email...');
  $emailSignup.find('.emailSignupText').html("Sign up for fair news and never miss the fun!");

  
  $('.emailSignupText').wrap('<div class="emailSignupTextWrapper"></div>');
  $('.emailInputField, .emailInputSubmit').wrapAll('<div class="emailInputWrapper"></div>');
  $('.emailSignupTextWrapper, .emailInputWrapper').wrapAll('<div class="emailSignupContainer"></div>');


  $('.searchBoxInput input').attr('placeholder', 'Search');
  $('.searchBoxInput input').val('');
  $('.header .searchBox .button').text('');
  $('.header .searchBox .searchBoxSubmit').after('<span class="search-word">Search</span>');
  $('.header .ticket').text('Get Tickets');

  $('.mobile-menu-container .mobile-menu-slider').after('<div class="mobile-ticket"></div>')
});


$(window).load(function () {
  if ($('body').hasClass('siteInfoBannerWidgetDateIsPast')) {
    $('.counter-container').remove();
  }

});